import LoginIndex from '@/Libs/Pages/Public/Auth/LoginIndex.vue'
import SignupIndex from '@/Libs/Pages/Public/Auth/SignupIndex.vue'
import ForgotPasswordIndex from '@/Libs/Pages/Public/Auth/ForgotPasswordIndex.vue'
import ResetPasswordIndex from '@/Libs/Pages/Public/Auth/ResetPasswordIndex.vue'

export default [
    {
        name: 'login',
        path: '/login',
        component: LoginIndex,
        meta: {
            title: 'signin.title.form',
            permission: null
        },
    },
    {
        name: 'signup',
        path: '/signup',
        component: SignupIndex,
        meta: {
            title: 'signup.title.form',
            permission: null
        },
    },
    {
        name: 'forgot-password',
        path: '/forgot-password',
        component: ForgotPasswordIndex,
        meta: {
            title: 'forgot_password.title.form',
            permission: null
        },
    },
    {
        name: 'reset-password',
        path: '/reset-password',
        component: ResetPasswordIndex,
        meta: {
            title: 'reset_password.title.form',
            permission: null
        },
    }
];